var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReports = function SvgReports(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.167 7.833h1.666v8.334h-1.666V7.832Zm3.333 3.333h1.667v5H14.5v-5Zm-6.667 1.667H9.5v3.333H7.833v-3.333Zm6.667-7.5H6.167v13.334h11.666v-10H14.5V5.332Zm-10-.84a.83.83 0 0 1 .832-.827h10.001L19.5 7.833v11.661a.833.833 0 0 1-.828.84H5.327a.834.834 0 0 1-.827-.828V4.493Z",
    fill: "#1D1737"
  })));
};
export default SvgReports;